import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getList({ searchParams, currentPage, pageUnit }) {
		try {
			const eqipKndCd = searchParams.eqipKndCd.length > 1 ? searchParams.eqipKndCd.join(',') : searchParams.eqipKndCd;
			let queryStr = '';
			queryStr = objectToQueryString({
				startMm: searchParams.strDt.replace('-', ''),
				endMm: searchParams.endDt.replace('-', ''),
				eqipKndCd,
				currentPage,
				pageUnit,
				mesEqipNo: searchParams.mesEqipNo?.trim(),
			});
			const response = await client.get(`${BASE_URL}/mmc/mmcm/mesCalAdsc/v1/mesCalAdscs${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
